module.exports = __webpack_public_path__ + "static/media/view student inquiry.df052af1.svg";